import CustomerOrders from "./customer-blocks/customer-orders";
import CustomerBalance from "./customer-blocks/customer-balance";
import CustomerPersonalInfo from "./customer-blocks/customer-personal-info";
import CustomerAddresses from "./customer-blocks/customer-addresses";
import CustomerRecipients from "./customer-blocks/customer-recipients";
import CustomerNotifications from "./customer-blocks/customer-notifications";
import CustomerMonthlyLimits from "./customer-blocks/customer-monthly-limits";
import {useEffect, useState} from "react";
import {SettingsContainer, SettingsTabContainer, UserTabs} from "../../../../pages/user/settings/styled";
import {ActionBar} from "../../../../pages/components/action-bar/action-bar";
import Message from "../../../../pages/components/message";
import {MessageSections} from "../../../../pages/components/message/message";
import {Tab} from "@mui/material";
import {useParams} from "react-router-dom";
import {
    getCities,
    getCountries,
    getProvinces,
    getRecipientDocumentTypes,
    getRegions
} from "../../../../redux/slices/static-data.slice";
import {useAppDispatch} from "../../../../redux/store";
import {User} from "../../../../pages/shared/models/user/user";
import allUsersService from "../../../../services/all-users.service";
import CustomerFiles from "./customer-blocks/customer-files";
import {TabType} from "../../../shared/enums";

export const CustomerView = () => {
    const [isReady, setIsReady] = useState(false);

    const [customer, setCustomer] = useState<User>();

    const [tabs, setTabs] = useState([] as ManagementTab[])
    const [tab, setTab] = useState<ManagementTab | undefined>(undefined);

    const {customerId} = useParams() // language abbreviation

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (customerId && +customerId) {
            Promise.allSettled([
                allUsersService.getUserById(+customerId),
                dispatch(getCountries()),
                dispatch(getProvinces()),
                dispatch(getCities()),
                dispatch(getRegions()),
                dispatch(getRecipientDocumentTypes()),
            ]).then(([customerResponse]) => {
                if (customerResponse.status === 'fulfilled') {
                    const customer = customerResponse.value?.data;
                    setCustomer(customer);

                    const userTabs = [
                        {
                            type: TabType.ORDERS,
                            messageKey: 'orders',
                            component: <CustomerOrders customer={customer}/>,
                        },
                        {
                            type: TabType.BALANCE,
                            messageKey: 'balance',
                            component: <CustomerBalance customer={customer}/>,
                        },
                        {
                            type: TabType.PERSONAL_INFO,
                            messageKey: 'personal_info',
                            component: <CustomerPersonalInfo customer={customer}/>,
                        },
                        {
                            type: TabType.DELIVERY_ADDRESSES,
                            messageKey: 'delivery_addresses',
                            component: <CustomerAddresses customer={customer}/>,
                        },
                        {
                            type: TabType.RECIPIENTS,
                            messageKey: 'recipients',
                            component: <CustomerRecipients customer={customer}/>,
                        },
                        {
                            type: TabType.NOTIFICATIONS,
                            messageKey: 'notifications',
                            component: <CustomerNotifications customer={customer}/>,
                        },
                        {
                            type: TabType.MONTHLY_LIMITS,
                            messageKey: 'monthly_limits',
                            component: <CustomerMonthlyLimits customer={customer}/>,
                        },
                        {
                            type: TabType.FILES,
                            messageKey: 'files',
                            component: <CustomerFiles customer={customer}/>,
                        },
                    ]
                    setTabs(userTabs);
                    setTab(userTabs[0]);

                    setIsReady(true);
                }
            })
        }
    }, [])

    const handleChange = (selectedType: { type: TabType; messageKey: string; component: JSX.Element}) => {
        setTab(selectedType);
    };

    if (isReady) {
        return (
            <SettingsContainer>
                <ActionBar withBackButton
                           headerText={<>{customer?.firstName} {customer?.lastName}</>}/>

                <UserTabs value={tab ? tab.type : 0}
                          variant={"scrollable"}
                          scrollButtons={true}>
                    {
                        tabs.map(tabInfo => {
                            return (
                                <Tab value={tabInfo.type}
                                     key={tabInfo.messageKey}
                                     label={<Message messageKey={tabInfo.messageKey} sectionId={MessageSections.USER}/>}
                                     onClick={() => handleChange(tabInfo)}
                                />
                            )
                        })
                    }
                </UserTabs>

                <SettingsTabContainer>
                    {tab ? tab.component : ''}
                </SettingsTabContainer>
            </SettingsContainer>
        );
    } else {
        return <></>
    }
}

export interface ManagementTab {
    type: TabType; messageKey: string; uniqueKey?: string; component: JSX.Element
}